import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';
import {
	SapIssueForm,
	Tagline,
	TopImpactStoriesDesktop,
	TopImpactStoriesMobile,
	TopImpactStoriesMobileProvider,
} from '#src/app/pages/homepage/shared/components';

export const HeroSectionInput: React.FC = () => {
	const {
		data: { topImpactStories },
	} = useHomepagePageData();

	return (
		<section data-testid="homepage-input-hero-section" className="text-typography-strong relative overflow-hidden">
			<div
				aria-hidden="true"
				className="from-background-base via-fill-information-weaker to-background-base absolute inset-x-0 top-0 h-full bg-linear-to-bl via-50% [mask-image:linear-gradient(to_bottom,black_0%,black_90%,transparent_100%)]"
			/>
			<div className="relative z-10 container pt-6 md:pt-11 lg:pt-[60px]">
				<div>
					<Text data-testid="homepage-hero-heading" variant="display" as="h1" className="m-0 text-center">
						<TranslateHtml value="corgi.homepage.hero_sunrise.title" />
						<span className="text-typography-brand dark:text-icon-brand">.</span>
					</Text>
					<Text data-qa="homepage-hero-subheading" variant="body" as="h2" className="mt-2 mb-8 text-center lg:mb-10">
						<Translate value="corgi.homepage.hero_section.subheading" />
					</Text>
					<SapIssueForm labelVariant="start-a-petition" />
					<Tagline linkVariant="draft-ready" />
				</div>

				{topImpactStories.length > 0 && <TopImpactStoriesDesktop layout="row" />}
			</div>
			{topImpactStories.length > 0 && (
				<TopImpactStoriesMobileProvider>
					<TopImpactStoriesMobile />
				</TopImpactStoriesMobileProvider>
			)}
		</section>
	);
};
